// extracted by mini-css-extract-plugin
export var body = "FaqBanner-module--body--1f9d8";
export var container = "FaqBanner-module--container--234ee";
export var description = "FaqBanner-module--description--559e9";
export var heading = "FaqBanner-module--heading--cd600";
export var ripple = "FaqBanner-module--ripple--6c195";